/* eslint-disable prettier/prettier */
/* eslint-disable */

export default {
  styleOverrides: {
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
};
